var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style.watermark, _vm.$style[_vm.ribbonPosition]]},[_c('a',{attrs:{"href":"https://onvocado.com/?utm_source=link&utm_medium=onvocado_popup","target":"_blank"}},[_c('span',{class:[_vm.$style.poweredBy]},[_vm._v("Powered by onvocado")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }